angular.module( 'acme.view.application.resources.staff.assign', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.resources.staff.assign.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var staffAssign = {
        name: 'application.resources.staff.assign',
        url: '/assign',
        views: {
          "subview-main": {
            controller: 'ResourcesStaffAssignController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/resources/staff/assign/assign.tpl.html'
          }
        },
        data: {
          pageTitle: 'Personnel Assignment',
          rule: function(permits) {
            // Allow if state is not in exclusions array
            return (permits.indexOf('application.resources.staff.assign') !== -1);
          }
        }
      };

    $stateProvider
      .state(staffAssign);
});
